'use client';
import { useRef } from 'react';

import type { Props as TextareaFieldProps } from '~shared/ui/molecules/TextareaField';
import { TextareaField } from '~shared/ui/molecules/TextareaField';

import { useAutosizeTextArea } from './useAutosizeTextArea';

export type Props = TextareaFieldProps & {
	maxGrowRows?: number;
};

export const AutosizeTextAreaField = ({ maxGrowRows, ...props }: Props) => {
	const ref = useRef<HTMLTextAreaElement | null>(null);
	useAutosizeTextArea(ref, { maxGrowRows });

	const refCallback = (el: HTMLTextAreaElement) => {
		ref.current = el;

		if (typeof props.ref === 'function') {
			props.ref(el);
		} else if (props.ref) {
			props.ref.current = el;
		}
	};

	return <TextareaField {...props} ref={refCallback} />;
};
